import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { OENCommand } from "../enums/oe-command.enum";

/**
 * BfxOrderEntryUpdateEvent
 * ----------------------------------
 * This model is intended to hold life-cycle events, intervention events and error events, received by the
 * _oeWorker. It has a number of properties which allow for differed application of display state and model state update.
 * Its main use is for keeping events that have been received during order entry model/display initialization on modify.
 */
export class OEUpdateEventModel {
  // must
  public ref: string;
  public orderState: CubiqTS.OrderState;
  // optional
  public cmdStateChange: OENCommand;
  public lockedForMod: boolean;
  public lockUserId: string;
  public lockInterface: boolean;
  public lockActions: boolean;
  public privatized: boolean;
  public subscriptionLifeCycleActive: boolean;
  public subscriptionInterventionActive: boolean;
  public subscriptionScratchpadActive: boolean;
  public data: any;
  public orderId: string;

  constructor(_ref: string, _orderState: CubiqTS.OrderState, _displayState: OENCommand = null) {
    this.ref = _ref;
    this.cmdStateChange = _displayState;
    this.orderState = _orderState;
    //
    this.lockedForMod = null;
    this.lockUserId = null;
    this.lockInterface = null;
    this.lockActions = null;
    this.privatized = null;
    this.subscriptionLifeCycleActive = null;
    this.subscriptionInterventionActive = null;
    this.subscriptionScratchpadActive = null;
    this.data = null;
    this.orderId = null;
  }
}
